// Edit helpers for an Εκτός Σόλων case (same rules as ViewCaseOutSolon).

// extra_info is a JSON string; returns {} for missing or broken values.
const cache = new Map();
export const extraOf = (row) => {
  const raw = row?.extra_info;
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  if (cache.has(raw)) return cache.get(raw);
  let parsed = {};
  try {
    parsed = JSON.parse(raw) || {};
  } catch {
    parsed = {};
  }
  if (cache.size > 500) cache.clear();
  cache.set(raw, parsed);
  return parsed;
};

// Returns the case with one field changed: note, diadikasia and katathesi
// are columns; everything else lives in extra_info (antikeimeno is also
// mirrored into userInput, as the classic page does).
export const applyOutSolonChange = (singleCase, { name, value }) => {
  let next = singleCase;
  if (name !== "note" && name !== "diadikasia") {
    next = { ...next, userInput: { ...next.userInput, [name]: value } };
  }
  if (name === "note" || name === "diadikasia" || name === "katathesi") {
    return { ...next, [name]: value };
  }
  return {
    ...next,
    extra_info: JSON.stringify({ ...extraOf(singleCase), [name]: value }),
  };
};

export const saveOutSolonCase = (api, singleCase) =>
  api.post(`/outsolon/${singleCase.id}`, JSON.stringify(singleCase));
